import React, { Component } from 'react'
import Popup from './Popup'
import styled from 'styled-components'
import { Form, Input, Checkbox } from 'formsy-react-components';
import { Row, Col } from 'react-bootstrap';
import './popup.css'
import { LogeButtonSlim } from '../../GeneralStyle'
import { inject } from 'mobx-react';

import config from 'react-global-configuration';

@inject('userStore')

class AcceptContractPopup extends Component {

  constructor(props) {
      super(props)
      this.state = {
        accepted: false,
        name: "",
        open: this.props.open,
      }

      this.openModal = this.openModal.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open)
      this.setState({ open: this.props.open })
      if(this.props.open && this.props.reopen)
        this.child.openModal()
  }

  openModal() {
  }

  render() {
    const currentYear = new Date().getFullYear()

    const contracts = this.props.userStore.contracts
    if(!contracts || !this.props.contract || !this.props.contract.id)
      return null

    const contract = contracts.find(element => element.objectId === this.props.contract.id); // Prev: ==

    if(!contract)
      return null

    const year = contract.year

    const isButtonDisabled = () => {
      if(this.state.accepted !== true)
        return true


      const name = this.state.name
      const {firstname, lastname } = this.props.userStore.me

      if(name.toLowerCase() == new String(firstname + " " + lastname).toLowerCase() || name.toLowerCase() == new String(lastname + " " + firstname).toLowerCase())
        return false

      return true
    }

    const { genderTitle, firstname, lastname } = this.props.userStore.me

    return (
      <Popup width="500px" height="auto" ref={instance => { this.child = instance; }} open={this.state.open}>
        <Heading>Vertrag für { year }</Heading>

        <Text style={{marginTop: 20}}>
            Sehr geehrter { genderTitle } { firstname } { lastname }, bitten akzeptieren Sie Ihren Vertrag für { year },
            welchen Sie in Ihrem Kontakt eMail Postfach finden können. Optional können Sie auch den <a href={config.get('CLOUDINARY_URL') + contract.url} target="_blank" style={{cursor: "pointer", textDecoration: "underline"}}>Vertrag Anzeigen</a>.
        </Text>

        <Text style={{marginTop: 10}}>
          Bitte akzeptieren Sie den Vertrag so bald wie möglich.
        </Text>
        {/*
        <Text style={{marginTop: 20}}><i>
          Hinweis: Sie können den Vertrag jederzeit unter "Rechnungen & Verträge" in Ihrer Member-Area akzeptieren,
        </i></Text>
        */}
        <Row className="accept-contract">
        <Form
          style={{marginTop: 10, textAlign: "center"}}
          className={'dashboard-form'}
          layout={'vertical'}>

          <Input
              name="name"
              label="IHR NAME (ohne Titel)"
              value={this.state.name}
              placeholder="Max Mustermann"
              type="text"
              style={{marin: 0, textAlign: "center"}}
              onChange={(name, value) => this.setState({ name: value })}
          />

          <Col md={12}>
          <Checkbox
              value={this.state.accepted}
              name="isHidden"
              label="Ich akzeptiere den Vertrag"
              onChange={(name, value) => this.setState({ accepted: value })}
          />
          </Col>

          <LogeButtonSlim
            hoverFontColor={"white"}
            disabledFontColor={"white"}
            style={{margin: "20px 0"}}
            hideBorder
            disabled={ isButtonDisabled() }
            onClick={() =>{ this.props.userStore.acceptContract(contract.objectId); if(this.props.accepted) this.props.accepted(contract.objectId)}}>
              Vertrag signieren
          </LogeButtonSlim><br />
        </Form>
        </Row>
        <a onClick={ () => { this.child.closeModal() }} style={{cursor: "pointer"}}>später akzeptieren</a>
      </Popup>
    )
  }
}

export default AcceptContractPopup;

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`

const Text = styled.p `
  color: black;
`



// WEBPACK FOOTER //
// /src/components/internal/Popups/AcceptContractPopup.js